export default __webpack_public_path__ + "static/media/MEDICALSERVICEUSAGEFORM.0b6dd672.png";